import { useClipboard } from "@chakra-ui/react";
import { useCustomToast } from "../ui_components/reusables";
// import { useCustomToast } from "../ui_components";

export default () => {
  const toast = useCustomToast();

  /**
   *
   * @param {*} textToCopy
   * @param {import("@chakra-ui/react").UseToastOptions} options
   */
  function copy(textToCopy, options) {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        toast({
          status: "success",
          title: "Copied!",
          description: "Link copied to clipboard.",
          ...options,
        });
      })
      .catch(() => {
        toast({
          status: "error",
          title: "Copy failed",
          description: "Could not copy text to clipboard.",
        });
      });
  }

  return { copy };
};
